/*
 * This file is part of glowingblue/orell-articles.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import Modal, { IInternalModalAttrs } from 'flarum/common/components/Modal';
import type Article from '../models/Article';
import type Mithril from 'mithril';

export interface ArticleDetailModalAttrs extends IInternalModalAttrs {
	article: Article;
}

export default class ArticleDetailModal extends Modal<ArticleDetailModalAttrs> {
	article!: Article;

	oninit(vnode: Mithril.Vnode<ArticleDetailModalAttrs, this>) {
		super.oninit(vnode);
		this.article = this.attrs.article;
	}

	className(): string {
		return 'ArticleDetailModal Modal--medium';
	}

	title(): Mithril.Children {
		return app.translator.trans('glowingblue-orell-articles.forum.work.modal.title');
	}

	content() {
		const publishedAt = new Date(this.article.publishedAt());
		const publishedAtLocalized = new Intl.DateTimeFormat(app.translator.getLocale() ?? undefined).format(publishedAt);

		return (
			<div className="Modal-body">
				<div className="Article-description">{m.trust(this.article.description())}</div>
				<div className="Article-details">
					<div className="Article-details-item">
						<span className="Article-details-item-label">{app.translator.trans('glowingblue-orell-articles.forum.work.modal.category')}</span>
						<span className="Article-details-item-value">{this.article.category()}</span>
					</div>

					<div className="Article-details-item">
						<span className="Article-details-item-label">{app.translator.trans('glowingblue-orell-articles.forum.work.modal.publisher')}</span>
						<span className="Article-details-item-value">{this.article.publisher()}</span>
					</div>

					<div className="Article-details-item">
						<span className="Article-details-item-label">{app.translator.trans('glowingblue-orell-articles.forum.work.modal.language')}</span>
						<span className="Article-details-item-value">{this.article.language()}</span>
					</div>

					<div className="Article-details-item">
						<span className="Article-details-item-label">{app.translator.trans('glowingblue-orell-articles.forum.work.modal.pages')}</span>
						<span className="Article-details-item-value">{this.article.pages()}</span>
					</div>

					<div className="Article-details-item">
						<span className="Article-details-item-label">{app.translator.trans('glowingblue-orell-articles.forum.work.modal.publishedAt')}</span>
						<span className="Article-details-item-value">{publishedAtLocalized}</span>
					</div>

					<div className="Article-details-item">
						<span className="Article-details-item-label">{app.translator.trans('glowingblue-orell-articles.forum.work.modal.isbn')}</span>
						<span className="Article-details-item-value">{this.article.isbn()}</span>
					</div>
				</div>
			</div>
		);
	}
}
